import { env } from "@/configs/env";
import { createServerFn } from "@tanstack/react-start";
import { getHeader } from "@tanstack/react-start/server";
import type { PartialDeep } from "type-fest";

interface DeploymentInfo {
  app: {
    name: string;
    hash: string;
    platform: string;
    environment: string;
  };
  worker: {
    instance: string;
    region: string;
  };
  edge: {
    region: string;
  };
}

export const getDeploymentInfo = createServerFn({ method: "GET" }).handler(
  () => {
    let partialDeploymentInfo: PartialDeep<DeploymentInfo> = {};
    if (env.FLY_MACHINE_ID) {
      partialDeploymentInfo = resolveDeploymentInfo_Fly();
    } else if (env.RAILWAY_SERVICE_NAME) {
      partialDeploymentInfo = resolveDeploymentInfo_Railway();
    }

    return {
      ...resolveDeploymentInfo_Bare(),
      ...partialDeploymentInfo,
    } as DeploymentInfo;
  },
);

function resolveDeploymentInfo_Bare() {
  return {
    app: {
      name: "mpx",
      hash: "",
      platform: "bare",
      environment: "N/A",
    },
    worker: {
      instance: "N/A",
      region: "N/A",
    },
    edge: {
      region: "N/A",
    },
  } satisfies DeploymentInfo;
}

function resolveDeploymentInfo_Fly() {
  return {
    app: {
      name: env.FLY_APP_NAME,
      hash: "",
      platform: "fly",
      environment: "N/A",
    },
    worker: {
      instance: env.FLY_MACHINE_ID,
      region: env.FLY_REGION,
    },
    edge: {
      region: getHeader("Fly-Region"),
    },
  } satisfies PartialDeep<DeploymentInfo>;
}

function resolveDeploymentInfo_Railway() {
  return {
    app: {
      name: env.RAILWAY_SERVICE_NAME,
      hash: env.RAILWAY_GIT_COMMIT_SHA,
      platform: "railway",
      environment: env.RAILWAY_ENVIRONMENT_NAME,
    },
    worker: {
      instance: env.RAILWAY_REPLICA_ID,
      region: env.RAILWAY_REPLICA_REGION,
    },
  } satisfies PartialDeep<DeploymentInfo>;
}
